import styled from "styled-components";

export const MTPContainer = styled.div`
  min-width: 78px;
`;
